import { type NavigationState } from 'src/types'

const defaultNavigation: NavigationState = {
  game_over: false,
  menu_open: false,
  stats_open: false,
  inventory_open: false,
  info_open: false,
  event_open: true,
  combat_open: false,
  enemy_ko: false,
  enemy_dead: false,
  enemy_spared: false,
  loot_open: false,
  stash_open: false
}

export {
  defaultNavigation
}
